/** @jsx jsx */
import { memo } from 'react';
import { jsx, css } from '@emotion/react';
import FocusRing from '@atlaskit/focus-ring';
import ChevronDownIcon from '@atlaskit/icon/glyph/chevron-down';
import ChevronUpIcon from '@atlaskit/icon/glyph/chevron-up';
import CrossIcon from '@atlaskit/icon/glyph/cross';
import { borderRadius as getBorderRadius, gridSize as getGridSize } from '@atlaskit/theme/constants';
import { useGlobalTheme } from '@atlaskit/theme/components';
import { getFlagTextColor } from '../theme';
var gridSize = getGridSize();
var borderRadius = getBorderRadius();
var dismissButtonStyles = css({
  marginLeft: gridSize,
  padding: 0,
  flex: '0 0 auto',
  appearance: 'none',
  background: 'none',
  border: 'none',
  borderRadius: borderRadius,
  cursor: 'pointer',
  lineHeight: '1',
  whiteSpace: 'nowrap'
});
var crossIconStyles = css({
  paddingTop: "".concat(gridSize, "px")
});

var DismissButton = function DismissButton(_ref) {
  var appearance = _ref.appearance,
      onClick = _ref.onClick,
      isBold = _ref.isBold,
      isExpanded = _ref.isExpanded,
      testId = _ref.testId;

  var _useGlobalTheme = useGlobalTheme(),
      mode = _useGlobalTheme.mode;

  var ButtonIcon = CrossIcon;
  var buttonLabel = 'Dismiss';
  var size = 'small';
  var buttonTestId = testId && "".concat(testId, "-dismiss");

  if (isBold) {
    ButtonIcon = isExpanded ? ChevronUpIcon : ChevronDownIcon;
    buttonLabel = isExpanded ? 'Collapse' : 'Expand';
    size = 'large';
    buttonTestId = testId && "".concat(testId, "-toggle");
  }

  return jsx(FocusRing, null, jsx("button", {
    style: {
      color: getFlagTextColor(appearance, mode)
    },
    css: [dismissButtonStyles, !isBold && crossIconStyles],
    onClick: onClick,
    "data-testid": buttonTestId,
    type: "button",
    "aria-expanded": isBold ? isExpanded : undefined
  }, jsx(ButtonIcon, {
    label: buttonLabel,
    size: size
  })));
};

export default /*#__PURE__*/memo(DismissButton);